import React from 'react';
import '../Styles/FirstLightContent.scss';

function FirstLight() {
    return (
        <div className="FLContent">
            <div className="Content">
                BLOG | DEVOTIONALS | PODCAST | SERMONS
            </div>

            <a href="/ministryresources">
             <button className="FLButton">Learn More</button>
            </a>
        </div> 
    )

}

export default FirstLight;
